export const presenceTopicName = (userId?: string) => userId ? `v2.users.${userId}.presence` : undefined;
